const PaymentMethodStatus = {
  OM: "om",
  WAVE: "wave",
  AGENT: "agent",
  KPAY: "kpay",
  CASH: "cash",
};

export const paymentMethod = Object.keys(PaymentMethodStatus).map((key) => ({
  value: PaymentMethodStatus[key],
  label: key,
}));
